<script>
  import { get } from 'svelte/store'
  import Datepicker from 'svelte-calendar'
  import pdfMake from 'pdfmake/build/pdfmake.min'
  import pdfFonts from 'pdfmake/build/vfs_fonts'
  import Modal from './Modal.svelte'
  import Button from './Button.svelte'
  import { modalStore, userStore, snackBarStore, locationStore, tenantStore } from './../state/store'
  import { t } from '../i18n/i18n'
  import { getLocationData } from './../state/actions'
  import { request } from './../helpers/api'
  pdfMake.vfs = pdfFonts.pdfMake.vfs
  
  export let client
  let dateFormat = '#{l}, #{F} #{j}, #{Y}'
  let startDate
  let endDate
  const minDate = new Date()
  minDate.setFullYear(minDate.getFullYear() -1)
  const maxDate = new Date()
  maxDate.setMonth(maxDate.getMonth() + 2)
  const openModal = () => modalStore.toggle('generate_report')

  getLocationData()

  const createReport = async () => {
    const start = startDate
    const end = endDate

    try {
      const response = await request({
        url: `/api/reports/?tenant=${$userStore.tenant_id}&clientId=${client._id}&start=${start}&end=${end}`
      })
      const styles = {
        header: {
          fontSize: 22,
          bold: true
        },
        tableHeader: {
          fontSize: 14,
          bold: true
        }
      }

      const generateTableBody = () => {
        let body = []
        response.forEach(({
          name,
          time_stamp,
          signature,
          coordinates,
          assignee,
          location_id,
          note = '(N/A)'
        } = record) => {
            body.push([         
              $locationStore.find(location => location._id === location_id).address,
              new Date(time_stamp).toDateString('en-US'),
              new Date(time_stamp).toLocaleTimeString('en-US'),
              name,
              {
                image: signature,
                height: 30,
                width: 90
              },
              note,
              {text: `Click here`, link: `https://www.google.com/maps/search/?api=1&query=${coordinates[1]},${coordinates[0]}`},
              assignee
            ])
          }
        )
        return body
      }

      const tableBody = generateTableBody()
      const docDefinition = {
        styles,
        pageOrientation: 'landscape',
        pageMargins: 20,
        info: {
          title: `${client.name} - ${new Date().toDateString()}`,
          creator: 'Contract Keeper',
          producer: 'Contract Keeper',
        },
        content: [
          { text: `Client - ${client.name}`, style: 'header', margin: [0, 0, 0, 5] },
          {
            table: {
              headerRows: 1,
              widths: ['auto', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto'],
              body: [
                [
                  {text: 'Location Address', style: 'tableHeader'},
                  {text: 'Date', style: 'tableHeader'},
                  {text: 'Time', style: 'tableHeader'},
                  {text: 'Signer Name', style: 'tableHeader'},
                  {text: 'Signature Recorded', style: 'tableHeader'},
                  {text: 'Notes', style: 'tableHeader'},
                  {text: 'Link To Captured Coordinates', style: 'tableHeader'},
                  {text: 'Serviced By', style: 'tableHeader'}
                ],
                ...tableBody
              ]
            }
          }
        ],
        footer: {text: `Report created on ${new Date().toDateString()}. Provided by ${get(tenantStore).name} `, alignment: 'right', margin: [0, 2, 20, 20] }
      }
      pdfMake.createPdf(docDefinition).download(`${client.name} - ${new Date().toDateString()}.pdf`)

    } catch (error) {
      snackBarStore.set({ message: $t.something_wrong, type: 'error' })
    }
  }

</script>

<style>
  .button {
    margin-top: 2rem;
  }

  .dates div {
    margin-top: 6rem;
    text-align: center;
  }

  @media (min-width: 767px) {
    .dates {
      display: flex;
      text-align: left;
      margin-top: 20rem;
      justify-content: space-evenly;
    }

    .dates div {
      text-align: left;
    }
  }

  .report-button {
    position: absolute;
    bottom: 1rem;
    right: 1rem;
  }

</style>

<div class="button">
  <Button on:click={openModal} size='full' class='button'>{$t['Generate Report']}</Button>
</div>
<Modal name='generate_report' large='true'>
  <h1 slot='header'>{$t['Select Dates']}</h1>
  <div class='dates'>
    <div>
      <p>{$t.start_date}</p>
      <Datepicker start={minDate} end={maxDate} format='{dateFormat}' bind:selected={startDate} />
    </div>
    <div>
      <p>{$t.end_date}</p>
      <Datepicker start={minDate} end={maxDate} format='{dateFormat}' bind:selected={endDate} />
    </div>
  </div>
  <div class="report-button">
    <Button on:click={createReport} >{$t['Get Report']}</Button>
  </div>
</Modal>